export default __webpack_public_path__ + "static/media/forward.ecb8a1f7.svg";